<template>
  <div>
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
      <select
        id="tabs"
        name="tabs"
        v-model="tab"
        class="p-2 block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
      >
        <option v-for="(value, index) in tabs" :key="value" :value="index" :selected="tab == index">
          {{ value }}
        </option>
      </select>
    </div>
    <div class="hidden sm:block">
      <nav class="flex space-x-4" aria-label="Tabs">
        <a
          v-for="(value, index) in tabs"
          :key="value"
          @click.prevent="tab = index"
          :href="`#`"
          :class="[
            tab === index ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700',
            'px-3 py-2 font-medium text-sm rounded-md',
          ]"
          :aria-current="tab === index ? 'page' : undefined"
        >
          {{ value }}
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
export default {
  props: {
    modelValue: [Number, String],
  },
  emits: ['update:modelValue', 'selected'],
  setup(props, { emit }) {
    const tabs = ['Information', 'Devis', 'Factures', 'Note de crédits']
    const tab = ref(typeof props.modelValue === 'undefined' ? 0 : Number(props.modelValue))
    const emitTab = tab => {
      emit('selected', tab)
      emit('update:modelValue', tab)
    }
    onMounted(() => emitTab(tab.value))
    watch(() => tab.value, emitTab)
    return {
      tabs,
      tab,
      emitTab,
    }
  },
}
</script>
